import { configureStore } from '@reduxjs/toolkit';
import { appReducer } from './slices/app/app.slice';
import { zoomReducer } from './slices/zoom/zoom.slice';
import { modalsReducer } from './slices/modals/modals.slice';
import { splitApi } from './api/split.api';

export function createReduxStore() {
  return configureStore({
    reducer: {
      app: appReducer,
      zoom: zoomReducer,
      modals: modalsReducer,
      [splitApi.reducerPath]: splitApi.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(splitApi.middleware),
  });
}

export const store = createReduxStore();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = ReturnType<typeof createReduxStore>['dispatch'];
